var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"text-timeseries text"},[_vm._v(_vm._s(_vm.name)+" "+_vm._s(_vm.$t('settings.needs_settings')))]),_c('a',{staticClass:"btn redirect-btn",on:{"click":function($event){return _vm.toSettings(_vm.notification.id)}}},[_vm._v(" "+_vm._s(_vm.$t('settings.to_settings'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }